import {
  DEPARTMENT_LOADING,
  GET_DEPARTMENT,
  GET_DEPTSTRUCTURE,
  GET_DEPARTMENT_SUCCESS,
  GET_DEPARTMENT_FAIL,
  ADD_DEPARTMENT_SUCCESS,
  ADD_DEPARTMENT_FAIL,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAIL,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAIL,
  DEPARTMENT_RESET
} from "./actionType";

const INIT_STATE = {
  departments: [],
  structures: [],
  error: {},
};

const Department = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DEPARTMENT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_DEPARTMENT:
          return {
            ...state,
            departments: action.payload.data,
            isDepartmentCreated: false,
            isDepartmentSuccess: true,
            loading: false,
          };

        case GET_DEPTSTRUCTURE:
          return {
            ...state,
            structures: action.payload.data,
            isDepartmentCreated: false,
            isDepartmentSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_DEPARTMENT_FAIL:
      switch (action.payload.actionType) {
        case GET_DEPARTMENT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isDepartmentCreated: false,
            isDepartmentSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_DEPARTMENT: {
      return {
        ...state,
        isDepartmentCreated: false,
        loading: true,
      };
    }

    case DEPARTMENT_LOADING: {
      return {
        ...state,
        isDepartmentCreated: false,
        loading: true,
      };
    }

    case ADD_DEPARTMENT_SUCCESS:
      return {
        ...state,
        isDepartmentCreated: true,
        loading: false,
        departments: [action.payload.data, ...state.departments],
      };

    case ADD_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        departments: state.departments.filter(
          department => department.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        departments: state.departments.map(department =>
          department.id.toString() === action.payload.data.id.toString() ? { ...department, ...action.payload.data } : department
        ),
      };

    case UPDATE_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DEPARTMENT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Department;